import { ECountryCode } from 'src/modules/forms/fields/AreaCodeTextField/components/AreaCodeSelect';

export type TServiceClientFormVehicle = {
    make: string;
    makeName: string;
    vehicleId: string;
    model: string;
    modelType: string;
    year: string;
    vin: string;
    kilometers: number;
};

export type TServiceClientFormValues = {
    name: string;
    email: string;
    phone: string;
    countryCode: ECountryCode;
    source: string;
    store: string;
    service: {
        vehicles: TServiceClientFormVehicle[];
    };
};

export interface IServiceClientFormProps {
    mode: 'create' | 'edit';
    initialValues?: Partial<TServiceClientFormValues>;
    onSubmit: (values: TServiceClientFormValues) => void | Promise<void>;
}

export const defaultServiceClientFormValues: TServiceClientFormValues = {
    name: '',
    email: '',
    phone: '',
    countryCode: ECountryCode.Mexico,
    source: '',
    store: '',
    service: {
        vehicles: [],
    },
};

export const emptyVehicleValues: TServiceClientFormVehicle = {
    make: '',
    makeName: '',
    vehicleId: '',
    model: '',
    modelType: '',
    year: '',
    vin: '',
    kilometers: 0,
};
